import { AppID } from '@playq/octopus-common';

import { IIssueOrSupportBrief } from '../types';

export const getEnabledOrPrefetchStatus = (optionsEnabled: boolean | undefined, appID: AppID | undefined): boolean => {
  return (optionsEnabled ?? true) && appID !== undefined;
};

export const getRowKey = (item: IIssueOrSupportBrief): string => {
  return item.id.serialize();
};
export const splitAtFirstUppercase = (name: string) => name.replace(/([a-z])([A-Z])/, '$1 $2');
